import { Button } from '@brighterion/br-ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ActivateMerchantModal from 'Routes/Overrides/components/ActivateMerchantModal';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import styles from './ActivateMerchantBtn.css';

type Props = {
    merchantId: string;
    templateRepositoryId: number;
    merchantEnabled: boolean;
};

const ActivateMerchantBtn = ({ merchantId, templateRepositoryId, merchantEnabled }: Props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [activateMerchantOpen, setActivateMerchantOpen] = useState(false);

    const toggleMerchant = () => {
        setActivateMerchantOpen(true);
    };

    return (
        <span className={styles.buttonWrapper}>
            <Button
                size='small'
                variant='secondary'
                dataTestId='reactivate-merchant'
                onClick={handleOnClickEvent(toggleMerchant)}
                onKeyDown={handleKeyEvent(toggleMerchant)}
            >
                {merchantEnabled ? t('Deactivate Merchant') : t('Reactivate Merchant')}
            </Button>
            <ActivateMerchantModal
                isOpen={activateMerchantOpen}
                onClose={() => setActivateMerchantOpen(false)}
                onSuccess={() => history.push('/overrides')}
                merchantId={merchantId}
                templateRepositoryId={templateRepositoryId}
                merchantEnabled={merchantEnabled}
            />
        </span>
    );
};

export default ActivateMerchantBtn;
